module.exports = __webpack_public_path__ + "static/media/image-anak-4.11d09e81.png";